import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const beyondTrust = defineConnector({
  identifier: "beyondTrust",
  name: "BeyondTrust Password Safe",
  tagLine: "Privileged access management",
  logo,
  protocol: "http",
  tags: ["security", "identity"],
  defaultUrlPattern: () => "https://[^/]*\\.beyondtrustcloud\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content: outdent`
            1. In your BeyondInsight console, go to **Configuration > General > API Registrations**
            2. Create a new API registration with the **API Access Policy** type
            3. Copy the **Client ID** and **Client Secret**
          `,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Instance URL",
          required: true,
          placeholder: "mycompany.beyondtrustcloud.com",
          helperText: "Your BeyondTrust hostname.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ host }) =>
      `https://${host}/BeyondTrust/api/public/v3/auth/connect/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ host }) => ({
      url: `https://${host}/BeyondTrust/api/public/v3/Workgroups`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ host }) => ({
    BEYOND_TRUST_URL: host ? `https://${host}` : "",
  }),
});
